const BASE64_MARKER = ';base64,'
export function dataURIToUint8Array(dataURI: string) {
  const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length
  const base64 = dataURI.substring(base64Index)
  const raw = window.atob(base64)
  const rawLength = raw.length
  const array = new Uint8Array(new ArrayBuffer(rawLength))

  for (let i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i)
  }
  return array
}

export const generateUint8ArrayFromFile = async (file: File) => {
  const buffer = await file.arrayBuffer()
  return new Uint8Array(buffer)
}

export const generateDTOFiles = async (files?: File[]) => {
  if (!files?.length) {
    return []
  }

  const promises = files.map((file) => generateUint8ArrayFromFile(file))
  return await Promise.all(promises)
}
